import Game from "../components/Game";
import { GameContextProvider } from "../contexts/GameContext";

const GamePage = () => {
    return (
        <div className="ll">
            <GameContextProvider>
                <Game prop=""/>
            </GameContextProvider>
        </div>

    );
};

export default GamePage;